"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Insights
 * OpenApi specification for the Insights.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetSchemaAllOfToJSON = exports.WidgetSchemaAllOfFromJSONTyped = exports.WidgetSchemaAllOfFromJSON = exports.instanceOfWidgetSchemaAllOf = exports.WidgetSchemaAllOfKindEnum = void 0;
/**
 * @export
 */
exports.WidgetSchemaAllOfKindEnum = {
    Placeholder: 'placeholder',
    ObservationPipeline: 'observationPipeline',
    CoverageScore: 'coverageScore',
    FleetHealthOverview: 'fleetHealthOverview',
    SensorsManifestOverview: 'sensorsManifestOverview',
    ReleaseOverview: 'releaseOverview',
    LoginByCountryMap: 'loginByCountryMap',
    BarChart: 'barChart',
    PieChart: 'pieChart',
    Table: 'table',
    AreaChart: 'areaChart',
    HorizontalBarChart: 'horizontalBarChart',
    BubbleMap: 'bubbleMap',
    GroupBarChart: 'groupBarChart',
    MultiAreaChart: 'multiAreaChart'
};
/**
 * Check if a given object implements the WidgetSchemaAllOf interface.
 */
function instanceOfWidgetSchemaAllOf(value) {
    var isInstance = true;
    isInstance = isInstance && "kind" in value;
    return isInstance;
}
exports.instanceOfWidgetSchemaAllOf = instanceOfWidgetSchemaAllOf;
function WidgetSchemaAllOfFromJSON(json) {
    return WidgetSchemaAllOfFromJSONTyped(json, false);
}
exports.WidgetSchemaAllOfFromJSON = WidgetSchemaAllOfFromJSON;
function WidgetSchemaAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kind': json['kind'],
    };
}
exports.WidgetSchemaAllOfFromJSONTyped = WidgetSchemaAllOfFromJSONTyped;
function WidgetSchemaAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'kind': value.kind,
    };
}
exports.WidgetSchemaAllOfToJSON = WidgetSchemaAllOfToJSON;
